// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"SearchBar_inputSearch__2bLbV","btnSearch":"SearchBar_btnSearch__qarHj"};